import { dds } from "../dds/ddsClient";
import { STATIC_STAT_CONFIG } from "../utils/statshelper";

/**
 * Fetches the centralized match-stats panel config (15 stats + Yellow/Red
 * Cards, shared identically by AeDrive and Aether) via DDS's getStatsConfig
 * query, which cache-asides (Redis) over bb_merge_db's `setting` collection
 * (key.collection_setting: "stats_config") — the same admin-config
 * mechanism/collection every other setting doc already uses. Cached in
 * memory for the session — one fetch per app load, not per component mount.
 */

let cachedConfig = null;

export const fetchStatsConfig = async () => {
  if (cachedConfig) return cachedConfig;

  try {
    const doc = await dds.getStatsConfig();
    if (doc?.stats?.length) {
      cachedConfig = [...doc.stats, ...(doc.cards || [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
      return cachedConfig;
    }
  } catch (err) {
    console.warn("[fetchStatsConfig] DDS fetch failed, falling back to static config:", err?.message);
  }

  // Backend unreachable or not yet seeded — fall back to the hardcoded list
  // below so the panel never renders empty.
  cachedConfig = STATIC_STAT_CONFIG;
  return cachedConfig;
};

export const getCachedStatsConfig = () => cachedConfig;
